import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Category } from '@/models/Category';
import MiButton from '@/components/mi-button/MiButton';
import { SubCategory } from '@/models/SubCategory';

@Component<CreateDialog>({
  components: {
    MiButton,
  },
})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected category!: Category;

  protected newCategory: Category = new Category();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.category) {
      this.newCategory = this.category.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }

  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newCategory.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if(!this.newCategory || !this.canSaveCategory) {
      return;
    }

    this.newCategory
    .update()
    .then((category: Category) => {
      this.isLoading = false;
      this.$emit('categoryUpdated', category);
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected create() {
    if (!this.canSaveCategory) {
      return;
    }

    this.isLoading = true;
    this.newCategory
    .create()
    .then((category: Category) => {
      this.isLoading = false;
      this.$emit('categoryCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected addSubCategory() {
    if(!this.newCategory.sub_categories) {
      this.$set(this.newCategory, 'sub_categories', [new SubCategory()]);
    } else {
      this.newCategory.sub_categories.push(new SubCategory());
    }
  }

  protected get canSaveCategory() {
    if(this.newCategory && this.newCategory.name && this.newCategory.name.length > 0 && this.newCategory.short_name && this.newCategory.short_name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    if(this.newCategory && this.newCategory.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected get dialogHeader() {
    if(this.newCategory && this.newCategory.id) {
      return `Edit ${this.newCategory.name}`;
    }
    return 'Create category';
  }

  protected clear() {
    this.newCategory = new Category();
  }
}
